import { checkAuthentication } from "../../api/firebaseFunctions";
import { createUserRecord, getAllUsers, removeUsersById, resetUserPasswordByEmail } from "../../api/userFirebase";

export const Types = {
    LOAD: 'users/LOAD',
    ADD: 'users/ADD',
    GET: 'users/GET',
    GET_ALL: 'users/GET_ALL',
    ERROR: 'users/ERROR',
    RESET: 'users/RESET',
    REMOVE: 'users/REMOVE',
}

const INITIAL_STATE = {
    type: null,
    data: null,
    loading: false,
    error: null,
};

export default function users(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.ADD: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.ERROR: {
            return {
                ...state,
                type: action.type,
                loading: false,
                error: action.payload
            }
        }
        case Types.LOAD: {
            return { ...state, type: action.type, loading: true }
        }
        case Types.GET: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.GET_ALL: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.UPDATE: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.REMOVE: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        default:
            return state;
    }
}

const addUsers = (data) => {
    return {
        type: Types.ADD,
        payload: data
    }
}

const errorUser = (data) => {
    return {
        type: Types.ERROR,
        payload: data
    }
}

const loading = () => {
    return {
        type: Types.LOAD,
    };
}

const getAllAvailableUsers = (data) => {
    return {
        type: Types.GET_ALL,
        payload: data
    }
}

const getCurrentUser = (data) => {
    return {
        type: Types.GET,
        payload: data
    }
}

const resetPassword = (data) => {
    return {
        type: Types.RESET,
        payload: data
    }
}

const removeUser = (data) => {
    return {
        type: Types.REMOVE,
        payload: data
    }
}

export const Creators = {
    createNewUserWithEmailAndPassword: (name, email, password) => {
        return (dispatch) => {
            dispatch(loading());
            createUserRecord({ name, email, password }, (res) => {
                if (res.error) {
                    dispatch(errorUser(res));
                }
                else {
                    dispatch(addUsers(res));
                }
            });
        }
    },
    getAllAvailableUsers: () => {
        return (dispatch) => {
            dispatch(loading());
            getAllUsers((res) => {
                dispatch(getAllAvailableUsers(res));
            });
        }
    },
    getCurrentUser: () => {
        return (dispatch) => {
            dispatch(loading());
            checkAuthentication((res) => {
                dispatch(getCurrentUser(res));
            });
        }
    },
    resetPassword: (email) => {
        return (dispatch) => {
            dispatch(loading());
            resetUserPasswordByEmail(email, (res) => {
                dispatch(resetPassword(res));
            });
        }
    },
    removeUserById: (uid) => {
        return (dispatch) => {
            dispatch(loading());
            removeUsersById(uid, (res) => {
                dispatch(removeUser(res));
            });
        }
    }
}
